<template>
    <woot-modal :show.sync="show" :on-close="onClose">
        <div class="column content-box">
            <woot-modal-header 
                :header-title="$t('INTEGRATION_APPS.FIPE.ADD.TITLE')" 
                :header-content="$t('INTEGRATION_APPS.FIPE.ADD.DESC')" 
            />
            <div class="box-tab">
                <woot-tabs :index="selectedTabIndex" @change="onClickTabChange">
                    <woot-tabs-item
                        v-for="tab in tabs"
                        :key="tab.key"
                        :name="tab.name"
                        :show-badge="false"
                    />
                </woot-tabs>
            </div>

            <form class="row" @submit.prevent="addFipe()">
                <div v-if="selectedTabIndex == 0">
                    <p>
                        {{ $t('IMPORT_CONTACTS.DESC')}}
                        <a class="btn-primary" :href="xlsxUrl" download="import-contacts-sample">XLSX</a>
                    </p>
                </div>
                <div class="medium-12 columns">
                    <label :class="{ error: $v.plan.$error }">
                        {{ $t('INTEGRATION_APPS.FIPE.ADD.FORM.PLAN.LABEL') }}
                        <select 
                            v-model="plan" 
                            @change="$v.plan.$touch" 
                        >
                            <option value="" disabled>
                                {{ $t('INTEGRATION_APPS.FIPE.ADD.FORM.PLAN.PLACEHOLDER') }}
                            </option>
                            <option v-for="option in plans" :key="option.id" :value="option.id">
                                {{ option.nome }}
                            </option>
                        </select>
                    </label>
                </div>



                <div v-if="selectedTabIndex == 0">
                    <label :class="{ error: $v.spreadsheet.$error }">
                        {{ $t('INTEGRATION_APPS.FIPE.ADD.FORM.SPREADSHEET.LABEL') }}
                        <input 
                            type="file" 
                            @change="onSpreadsheet" 
                        />
                    </label>
                </div>

                <div class="medium-12 columns" v-if="selectedTabIndex == 1">
                    <div class="medium-12 columns">
                        <label :class="{ error: $v.price.$error }">
                            {{ $t('INTEGRATION_APPS.FIPE.ADD.FORM.PRICE.LABEL') }}
                            <input 
                                v-model.trim="price" 
                                type="text"
                                @keypress="validateNumberInput" 
                                step="any" 
                                :placeholder="$t('INTEGRATION_APPS.FIPE.ADD.FORM.PRICE.PLACEHOLDER')" 
                                @input="$v.price.$touch" 
                            />
                        </label>
                    </div>
                    <div class="medium-12 columns">
                        <label :class="{ error: $v.fipeMin.$error }">
                            {{ $t('INTEGRATION_APPS.FIPE.ADD.FORM.FIPE_MIN.LABEL') }}
                            <input 
                                v-model.trim="fipeMin" 
                                type="number"
                                @keypress="validateNumberInput" 
                                step="any" 
                                :placeholder="$t('INTEGRATION_APPS.FIPE.ADD.FORM.FIPE_MIN.PLACEHOLDER')" 
                                @input="$v.fipeMin.$touch" 
                            />
                        </label>
                    </div>
                    <div class="medium-12 columns">
                        <label :class="{ error: $v.fipeMax.$error }">
                            {{ $t('INTEGRATION_APPS.FIPE.ADD.FORM.FIPE_MAX.LABEL') }}
                            <input 
                                v-model.trim="fipeMax" 
                                type="number"
                                @keypress="validateNumberInput" 
                                step="any" 
                                :placeholder="$t('INTEGRATION_APPS.FIPE.ADD.FORM.FIPE_MAX.PLACEHOLDER')" 
                                @input="$v.fipeMax.$touch" 
                            />
                        </label>
                    </div>

                </div>

                <div class="modal-footer">
                    <div class="medium-12 columns">
                        <woot-submit-button 
                            :disabled="isFormInvalid" 
                            :button-text="$t('INTEGRATION_APPS.FIPE.ADD.FORM.SUBMIT')" 
                            :loading="addFipeLoading" 
                            class="bg-primary" 
                        />
                        <button class="button clear" @click.prevent="onClose">
                            {{ $t('INTEGRATION_APPS.FIPE.ADD.CANCEL_BUTTON_TEXT') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </woot-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import xlsx from 'xlsx';



export default {
    mixins: [alertMixin],
    props: {
        onClose: {
            type: Function,
            default: () => {},
        },
        integration: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            plan: '',
            fipeMin: '',
            fipeMax: '',
            price: '',
            spreadsheet: null,
            addFipeLoading: false,
            show: true,
            selectedTabIndex: 0,
        };
    },
    computed: {
        ...mapGetters({
            plans: 'getPlanQuotations',
        }),
        xlsxUrl() {
            return '/downloads/example-cotacao.xlsx';
        },
        tabs() {
            return [
                {
                    key: 0,
                    name: this.$t('INTEGRATION_APPS.FIPE.ADD.FORM.TABS.AUTOMATIC'),
                },
                {
                    key: 1,
                    name: this.$t('INTEGRATION_APPS.FIPE.ADD.FORM.TABS.MANUAL'),
                },
            ];
        },
        isFormInvalid() {
            if (this.selectedTabIndex === 0) {
                return (
                    this.$v.plan.$invalid || 
                    this.$v.spreadsheet.$invalid || 
                    !this.spreadsheet || 
                    this.addFipeLoading
                );
            }
            return (
                this.$v.plan.$invalid || 
                this.$v.fipeMin.$invalid || 
                this.$v.fipeMax.$invalid || 
                this.$v.price.$invalid || 
                this.addFipeLoading
            );
        },
    },
    validations() {
        return {
            plan: {
                required,
            },
            spreadsheet: {
                required,
            },
            fipeMin: {
                required,
                minValue: minValue(0),
            },
            fipeMax: {
                required,
                minValue: minValue(0),
            },
            price: {
                required,
                minValue: minValue(0),
            },
        };
    },
    methods: {

        validateNumberInput(event) {
            const char = String.fromCharCode(event.keyCode);
            const validChars = '0123456789.';
            const inputValue = event.target.value;

            if (!validChars.includes(char)) {
                event.preventDefault();
            }

            if (char === '.' && inputValue.includes('.')) {
                event.preventDefault();
            }
        },

        onSpreadsheet(e) {
            const file = e.target.files[0];
            if (!file) return;
        
            const reader = new FileReader();
            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = xlsx.read(data, { type: 'array' });
        
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
        
                const jsonData = xlsx.utils.sheet_to_json(worksheet);
                this.spreadsheet = jsonData;
            };
        
            reader.readAsArrayBuffer(file);
        },
        onClickTabChange(index) {
            this.selectedTabIndex = index;
            this.resetForm();
        },
        resetForm() {
            this.plan = '';
            this.fipeMin = '';
            this.fipeMax = '';
            this.price = '';
            this.spreadsheet = null;
            this.$v.plan.$reset();
            this.$v.fipeMin.$reset();
            this.$v.fipeMax.$reset();
            this.$v.price.$reset();
            this.$v.spreadsheet.$reset();
        },
        addFipe() {
            this.addFipeLoading = true;

            const payload = {
                plano: this.plan,
                plan_name: this.plans.find((p) => p.id === this.plan)?.nome,
                plan_id: this.plans.find((p) => p.id === this.plan)?.id,
                fipeMinimo: this.selectedTabIndex === 1 ? this.fipeMin : null,
                fipeMaximo: this.selectedTabIndex === 1 ? this.fipeMax : null,
                preco: this.selectedTabIndex === 1 ? this.price : null,
                data: this.selectedTabIndex === 0 ? this.spreadsheet : null,
                type: this.selectedTabIndex === 0 ? 'automatic' : 'manual',
            };

            this.$store.dispatch('createFipe', payload)
                .then(() => {
                    this.addFipeLoading = false;
                    this.showAlert(this.$t('INTEGRATION_APPS.FIPE.ADD.API.SUCCESS_MESSAGE'));
                    this.resetForm();
                    this.onClose();
                })
                .catch((error) => {
                    this.addFipeLoading = false;
                    const errorMessage = this.$t('INTEGRATION_APPS.FIPE.ADD.API.ERROR_MESSAGE');
                    this.showAlert(errorMessage);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.box-tab {
    margin-left: 2rem;
}
</style>